import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { IMenu } from 'src/app/shared/models';

@Component({
  selector: 'app-roles',
  templateUrl: './roles.component.html',
  styleUrls: ['./roles.component.scss']
})
export class RolesComponent implements OnInit {

  constructor(private router: Router) { }

  menu: IMenu[] = [
    { title: 'Список', route: 'list' },
    { title: 'Добавить', route: 'add' },
  ];

  activeIndex = 0;

  ngOnInit() {
    this.router.navigate(['main/roles/list']);
  }
  selectList(i: number) {
    this.activeIndex = i;
  }

}
